import Team from '@/models/Team/team';

export default class Player {
  constructor({
    displayName = null,
    slug = null,
    age = null,
    pictureUrl = null,
    position = null,
    countryFlagUrl = null,
    last15Average = null,
    club = null,
    nationalTeam = null,
    scores = [],
  } = {}) {
    this.displayName = displayName;
    this.slug = slug;
    this.age = age;
    this.pictureUrl = pictureUrl;
    this.position = position;
    this.countryFlagUrl = countryFlagUrl;
    this.last15Average = last15Average;
    this.club = club ? Team.createFromObject(club) : null;
    this.nationalTeam = nationalTeam ? Team.createFromObject(nationalTeam) : null;
    this.scores = scores.reverse();
  }

  static createFromObject(data) {
    return new Player(data);
  }
}
